<template>
  <div>
    <div class="find-result-items">
      <div class="find-result-item" :class="{ 'is-selected': selected }">
        <a href="#" @click.prevent="selectStore"
          ><h3>{{ mapDataItem.name }}</h3
          ><span v-if="distanceText" class="find-result-distance">{{ distanceText }}</span>
          <div class="classify-items">
            <em class="classify-item" v-for="(tag, index) in mapDataItem.tag" :key="index">
              <span class="icon" v-if="tag.includes('wifi')">와이파이</span>
              <span class="icon" v-if="tag.includes('parking')">주차장</span>
              <span class="icon" v-if="tag.includes('earaid')">보청기</span>
              <span class="icon" v-if="tag.includes('lens')">렌즈샵</span>
              <span class="icon" v-if="tag.includes('fitting')">누진피팅센터</span>
            </em>
          </div>
          <div class="find-result-item-desc">
            <p>
              <span>
                {{ mapDataItem.addr }}
              </span>
            </p>
            <p>{{ mapDataItem.tel }}</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { formatKm } from "@/utils/storeFinder";

export default {
  props: {
    mapDataItem: { type: Object, required: true },
    // 지금 고른 매장 (목록에서 파란 배경으로 표시)
    selected: { type: Boolean, default: false },
    // 위치 허용 시 현재 위치와의 직선거리(km)
    distanceKm: { type: Number, default: null },
  },

  data() {
    return {
      iconSrc: "https://img.davich.com/image/sub/support/map/icon-store-all.png",
    };
  },

  computed: {
    distanceText() {
      return formatKm(this.distanceKm);
    },
  },

  methods: {
    selectStore() {
      this.$emit("moveLocation", this.mapDataItem);
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";
.m-find-store {
  // 분류결과
  .find-result-items {
    flex: 1;
    @include scroll-bar;
    .find-result-item {
      border-bottom: 1px solid #dedede;

      // 고른 매장 (간편상담 신청자 정보 선택 색과 같은 톤)
      &.is-selected {
        background-color: #e7f2ff;
        box-shadow: inset 4px 0 0 $color-blue;
      }

      > a {
        position: relative;
        display: block;
        width: 100%;
        padding: 20px;
        h3 {
          font-weight: bold;
          font-size: 20px;
          line-height: 35px;
          letter-spacing: 0.6px;
          display: inline-block;
          margin-right: 15px;
          // 오른쪽 위 거리(km) 자리 확보
          max-width: calc(100% - 60px);
        }
        .find-result-distance {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 15px;
          font-weight: 500;
          line-height: 35px;
          color: $color-blue;
        }
        .find-result-item-desc {
          p {
            font-size: 14px;
            line-height: 28px;
            color: #777;
          }
          button {
            display: inline-block;
            width: 50px;
            height: 30px;
            border: 1px solid #dedede;
            font-size: 13px;
            line-height: 30px;
            color: #777;
            border-radius: 15px;
          }
        }
        // 모바일: 제목(20→18px)과 주소·전화(14→15px) 차이를 줄이고, 주소 색을 조금 진하게(#777→#666, 흰 바탕 대비 4.5:1 이상)
        // 기준: iOS 제목 17pt·부제 15pt, Material 본문 16sp, 토스 목록 제목 17~18px
        @media screen and (max-width: 768px) {
          padding: 16px 20px;
          h3 {
            font-size: 18px;
            line-height: 26px;
            letter-spacing: -0.2px;
          }
          .find-result-distance {
            top: 16px;
            line-height: 26px;
          }
          .find-result-item-desc {
            margin-top: 4px;
            p {
              font-size: 15px;
              line-height: 22px;
              color: #666;
            }
          }
        }
      }
    }
  }

  // 분류
  .classify-items {
    margin-bottom: 10px;
    font-size: 14px;
    display: inline-block;
    .classify-item {
      display: inline-block;
      margin-right: 20px;
      position: relative;
      color: #aaa;
      align-items: center;

      &:before {
        content: "";
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        right: -10px;
        background-color: #aaa;
      }
      &:last-child:before {
        display: none;
      }
    }
  }
}
</style>
